import { Card, CardContent } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

export const OnStreetSkeletonView = () => {
  return (
    <div className="flex items-stretch w-full">
      <div className="flex flex-col mr-14 justify-between w-96">
        <Skeleton className="h-11" />
        <Skeleton className="h-24" />
        <Skeleton className="h-24" />
        <Skeleton className="h-24" />
      </div>
      <div className="grow flex flex-col mr-2">
        <Card className="rounded-2xl space-y-4 bg-white">
          <CardContent className="h-96 w-full">
            <Skeleton className="h-96" />
          </CardContent>
        </Card>
      </div>
    </div>
  );
};
